<template>
  <div class="gallery" :class="`columns--${columns || '2'}`">
    <div v-for="(img, idx) in content"
         :key="idx"
         class="gallery__image"
         @click="() => onShow(idx)">
				<svg version="1.1" class="magnify" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 407.2 406.7" style="enable-background:new 0 0 407.2 406.7" xml:space="preserve">
					<path class="magnify__path" fill="#fff" d="M160.4 1.9c13.8-.8 26.7.6 39.5 3.4 7.4 1.6 14.3 4.4 21.4 6.7 12 3.9 22.9 10.3 33.1 17.4 27 18.8 46.9 43.5 58.8 74.3 4.7 12.2 7.8 24.7 9.4 37.7 1.1 8.8 2 17.6 1.6 26.4-1.1 22.2-5.8 43.6-15.6 63.6-2.9 5.8-5.7 11.6-9.4 17-1.3 1.9-1.1 3.1.6 4.8 34.2 34 68.2 68.1 102.4 102.1 2.7 2.7 2.9 4.3-.5 6.2-1.2.7-2.2 1.8-3.1 2.8-12.6 13-26 25.2-38.1 38.7-.9 1-1.7 1.3-2.7.1-.5-.7-1.2-1.2-1.8-1.8-33.7-33.7-67.4-67.3-101-101.1-2.3-2.3-3.9-3.1-7.1-1-5.9 4-12.1 7.9-18.7 10.5-9.6 3.7-19.4 7-29.4 9.6-17.1 4.6-34.4 4.2-51.7 3.8-13.5-.4-26.3-4.6-39.1-8.8-9.8-3.2-18.7-8.1-27.9-12.6-5.1-2.5-10.2-5.7-14.5-9.6-5.7-5.2-11.8-9.9-17.3-15.3-13.4-13.1-23.3-28.6-32-45.1-4.3-8.3-6.4-17.3-9.5-25.9-3.5-9.5-3.6-19.4-5-29.1-1.3-8.7-1-17.5-.6-26.2.6-11.1 2.6-22.1 5.8-32.8 4.7-15.9 11.5-30.9 20.7-44.7 4.2-6.3 8.9-12.3 13.9-18 5.1-5.8 10.6-11.2 16.5-16.1 7.6-6.5 15.9-12.2 24.6-17.2 14-8.1 29.1-13.5 44.7-17.2C139 2 150 .8 160.4 1.9zm3.7 275.6c6.5-.4 13 0 19.6-1.6 12.5-2.9 24.6-6.5 35.7-13 18.5-10.7 33.2-25.1 44-43.8 9.3-16.1 13.5-33.5 15-51.7 1.1-13.6-1.8-26.7-5.4-39.7-4.9-17.7-14.5-33-27.4-45.9-6.7-6.7-14.4-12.6-22.5-17.8-18.3-11.8-38.6-16-59.8-17.1-11-.5-21.8 1.6-32.3 4.7-22.6 6.8-41.8 18.5-56.7 37.4-5.4 6.9-10.7 13.8-14.5 21.5-10.3 20.9-14.3 43.1-11.3 66.5 1.9 14.6 6.3 28.3 13.5 41.2 8 14.4 18.3 27 31.7 36.6 21 14.9 44.2 23.7 70.4 22.7z" />
				</svg>
				<img v-if="img.image.asset != null"
								 :src="$urlFor(img.image.asset.url, 1500)"
								 :alt="img.alt != null ? (locale === 'en' ? img.alt.en : img.alt.jp) : ''"
								 loading="lazy"
								 :width="img.image.asset.metadata.dimensions.width"
								 :height="img.image.asset.metadata.dimensions.height"
								 sizes="sm:100vw md:50vw lg:600px"/>
    </div>
  </div>

  <client-only>
    <vue-easy-lightbox
      :scrollDisabled="false"
      :moveDisabled="true"
      :rotateDisabled="true"
      :zoomDisabled="true"
      :resizeDisabled="true"
      :visible="visibleRef"
      :index="indexRef"
      :imgs="projectImages"
      @hide="onHide"
    />
  </client-only>
</template>

<script setup>
import { useI18n } from '#imports'
const { locale } = useI18n()
import {ref} from "vue"
const props = defineProps({
  content: Object,
	columns: String
})
const projectImages = [];
for(let i = 0; i < props.content.length; i++) {
	if(props.content[i].image.asset != null){
		projectImages.push(props.content[i].image.asset.url)
	}
}
const visibleRef = ref(false)
const indexRef = ref(0)
const onShow = (index) => {
  indexRef.value = index
  visibleRef.value = true
}
const onHide = () => (visibleRef.value = false)
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.gallery {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 100%;
  width: 100%;
  margin: 0 0 1rem 0;
  @include v.respond-to('small') {
		grid-gap: 1rem;
		margin: 0 0 3rem 0;
  	&.columns--2 {
			grid-template-columns: repeat(2, 1fr);
		}
		&.columns--3 {
			grid-template-columns: repeat(3, 1fr);
		}
		&.columns--4 {
			grid-template-columns: repeat(4, 1fr);
		}
	}
  .gallery__image {
    cursor: pointer;
		display: inline-block;
    height: 9rem;
    margin: 0;
		overflow: hidden;
		position: relative;
		width: 100%;
    @include v.respond-to('small') {
      height: 21rem;
    }
		.magnify {
			background-color: v.$transparentBg--faint;
			border-bottom-left-radius: 0.5rem;
			padding: 0.5rem;
			position: absolute;
			right: 0;
			top: 0;
			transition: 0.3s;
			width: 2rem;
			height: 2rem;
			&__path {
				fill: v.$white;
				height: 1.5rem;
				width: 1.5rem;
			}
		}
		&:hover {
			.magnify {
				background-color: v.$teal;
				transition: 0.3s;
				&__path {
					fill: v.$white;
				}
			}
		}
    img {
      object-fit: cover;
			object-position: center;
      width: 100%;
			height: 9rem;
      @include v.respond-to('small') {
        height: 21rem;
      }
    }
  }
}
</style>
